import { baseApi } from '../../../shared/api/baseApi';
import type { CleanupStatusDto, StoragePageDto } from '../model/dto';
import { toStoragePage } from '../model/mappers';
import type { StoragePage, StorageQuery } from '../model/types';

const ENDPOINT = '/api/admin/storage';

const TAG = 'StorageCleanup' as const;
const LIST_TAG = 'StorageList' as const;

export const storageApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getCleanupStatus: build.query<boolean, void>({
            query: () => `${ENDPOINT}/get_cleanup_status`,
            transformResponse: (response: CleanupStatusDto) => response?.status === true,
            providesTags: [{ type: TAG, id: 'STATUS' }],
        }),

        toggleCleanupStatus: build.mutation<boolean, boolean>({
            query: (status) => ({
                url: `${ENDPOINT}/toggle-cleanup`,
                method: 'POST',
                body: { status },
            }),
            transformResponse: (response: CleanupStatusDto) => response?.status === true,
            invalidatesTags: [{ type: TAG, id: 'STATUS' }],
        }),

        getStorageList: build.query<StoragePage, StorageQuery>({
            query: ({ scope, pageNum, pageSize, query = '' }) => ({
                url: `${ENDPOINT}/${scope}`,
                params: { page_size: pageSize, page_num: pageNum, query },
            }),
            transformResponse: (response: StoragePageDto) => toStoragePage(response),
            providesTags: (_result, _error, { scope }) => [{ type: LIST_TAG, id: scope }],
        }),
    }),
    overrideExisting: false,
});

export const { useGetCleanupStatusQuery, useToggleCleanupStatusMutation, useGetStorageListQuery } = storageApi;